import { useEffect } from "react"

// Sends the browser to a page on another site, replacing this history
// entry. For in-app links to pages that moved to getchaperon.com (About,
// Privacy, Terms): a client-side navigation never reaches server.js's 301.
export default function ExternalRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to)
    }, [to])
    return null
}
